<template>
  <div :class="{'newpage':flag === true,'hideleft':hide === true}" class="page">
    <div class="page-main">
      <div class="home-tier-1 ub-box">
        <div class="tier-1-block ub-box z-width-32-precent ub-col">
          <div class="user-detail-container ub-box">
            <div class="user-avatar ub-box ub-ver">
              <div class="user-avatar-container ub-box ub-ver">
                <div class="user-img-container ub-box ub-ver">
                  <img style="margin-top: 11px;" src="../../assets/imgs/user.png" alt="">
                </div>
              </div>
            </div>
            <div style="padding-top:3.6rem;">
              <div class="z-margin-bottom-20-precent z-relative ub-box">
                <span class="z-font-size-18 z-lines-1-overflow-hidden">您好，{{username}}</span>
                <router-link v-if="!(cname == '审核成功')" to="/auth" class="user-label un-auth user-verified-origin">
                  <span v-if="!(cname == '审核成功') && ajax" class="auth-bg">
                  <i class="auth-bg-icon"></i>
                  未实名认证
                </span>
                </router-link>
                <router-link v-if="cname == '审核成功'" to="/auth" class="user-label auth_inauth"></router-link>
              </div>
              <div>会员ID：{{userid}}</div>
            </div>
          </div>
          <div>
            <div class="user-connect z-padding-h-15-precent ub-box ub-between">
              <span class="connect-icon-mobile z-font-size-14 z-color-999 z-display-block">手机号码</span>
              <span class="z-display-block"><span v-if="phone==='立即绑定>>'" class="z-color-999 z-font-size-14">尚未绑定 </span><router-link class="z-font-size-14 z-color-blue" to="/user4">{{phone}}</router-link></span>
            </div>
            <div class="user-connect z-padding-h-15-precent ub-box ub-between">
              <span class="connect-icon-email z-font-size-14 z-color-999 z-display-block">电子邮箱</span>
              <span class="z-display-block"><span v-if="email==='立即绑定>>'" class="z-color-999 z-font-size-14">尚未绑定 </span><router-link class="z-font-size-14 z-color-blue" to="/user5">{{email}}</router-link></span>
            </div>
          </div>
        </div>
        <div class="tier-1-block ub-box z-width-32-precent z-margin-left-20-precent ub-col">
          <div class="home-panel-heading-notic ub-box ub-between z-font-size-16">
            <span class="notice-title z-textAlign-center z-font-size-16 z-padding-h-20-precent">
									阿贝云公告
								</span>
            <a class="font-size-12 line-height-1 z-color-blue" href="/help/?id=110" target="_blank">更多 &gt;&gt;</a>
          </div>
          <div class="notice-list-panel ub-box">
            <ul class="z-width-100-precent">
              <li v-for="(item,index) in gonggaoList" v-if="item.title && index<5" class="ub-box ub-between">
                <span class="notice-content z-oneline-overflow-hidden">
                  <span class="list-decoration-point">•</span>
                  <a :href="'/help/content_'+ item.id +'.html'" :title="item.title" target="_blank">{{item.title}}</a>
                </span>
                <span class="z-color-999">
                  {{item.setdate.split(' ')[0]}}
								</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="tier-1-block ub-box z-width-32-precent z-margin-left-20-precent ub-col">
          <ul class="ub-box home-nav z-width-100-precent">
            <li class="z-width-33-precent z-textAlign-center" v-for="(list , couponidx) in couponList" :class="{'active': couponidx === couponIndex}" @click.stop="clickCoupon(couponidx)">
              <a href="javascript:;">{{list.babel}}</a>
            </li>
          </ul>
          <div ref="couponItems" class="tab-content ub-box">
            <div class="tab-pane z-width-100-precent" v-for="(list , couponidx) in couponList" :class="{'active': couponidx === couponIndex}">
              <xul :columns="couponcolumns" :data="list['content']"/>
              <div v-if="list['length'] > 3" class="z-width-100-precent z-height-30-prcent z-textAlign-right">
                <span class="font-size-12 z-lineHeight-30 z-display-inlineBlock z-textAlign-right z-padding-right-10-precent z-color-blue z-curPonit" @click="moreCoupon">更多 &gt;&gt;</span>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="tier-1-block ub-box z-margin-top-20-precent ub-col">
        <div class="home-panel-heading-notic ub-box z-font-size-16">
            <span class="notice-title z-textAlign-center z-font-size-18 z-padding-h-20-precent" style="color:red;">
									促销专区
            </span>
        </div>
        <div v-for="item in Sales" class="pkg-card pkg-card-col">
          <div class="pkg-title">
            <em>{{item.cpu}}</em>核<em>{{item.ram}}</em>G
            <span v-if="item.ssd == 20" class="miaosha">秒杀</span>
          </div>
          <div class="pkg-deploy cf">
            <div class="dropdown " style="width: 200px;">
              <div class="ui-title z-textAlign-center" style="margin-left: -13px;">数据中心</div>
              <div class="ui-title">
                <el-radio-group v-model="item.NET_TYPE" size="mini">
                  <el-radio-button label="BJBGP" style="margin-right: 0">高防BGP</el-radio-button>
                  <el-radio-button label="DLBGP">东北BGP</el-radio-button>
                </el-radio-group>
              </div>
            </div>
            <div class="dropdown ">
              <div class="ui-title">带宽</div>
              <div class="ui-title">{{item.NET_WIDTH}}M</div>
            </div>
            <div class="dropdown ">
              <div class="ui-title">数据盘</div>
              <div class="ui-title" :style="{color:(item.disc == 20 ? '#ff6600':'')}">{{item.disc}}G</div>
            </div>
            <div class="dropdown ">
              <div class="ui-title">免费获赠</div>
              <div class="ui-title">操作系统盘</div>
            </div>
          </div>
          <div class="pkg-order">
            <!--<p class="price"><span class="pkg-price">¥{{item.price}}</span><span class="unit darkgray">元/<span v-if="item.p_time == 1">首月</span><span v-if="item.p_time == 12">首年</span></span></p>-->
            <el-radio-group v-model="item.cx_time" size="medium">
              <el-radio-button v-if="item.y_price3" label="6">{{item.y_price3}}元/3年</el-radio-button>
              <el-radio-button v-if="item.y_price2" label="5">{{item.y_price2}}元/2年</el-radio-button>
              <el-radio-button v-if="item.y_price" label="4">{{item.y_price}}元/年</el-radio-button>
              <el-radio-button v-if="item.s_price != 0" label="3">{{item.s_price}}元/季度</el-radio-button>
              <el-radio-button v-if="item.x_price" label="2">{{item.x_price}}元/月</el-radio-button>
              <el-radio-button v-if="item.d_price != 0" label="1">{{item.d_price}}元/天</el-radio-button>
            </el-radio-group>
            <a class="btn-m btn-red pkg-href" @click="addCart(item)" href="javascript:;">立即开通</a>
          </div>
        </div>
      </div>
      <div class="home-tier-2 z-margin-top-20-precent ub-box">
        <div class="operate-container ub-box z-width-100-precent">
          <div class="operate-container-left ub-box z-width-50-precent">
            <div class="operate-links ub-box">
              <span class="z-color-999 z-margin-right-5-precent">可用余额：</span>
              <span class="detail-count-container z-font-size-16">
									<span class="user-balance z-font-size-22">{{money}}</span><span>.{{smoney}}</span> 元
								</span>
              <el-button type="primary" style="background-color: #FF8800;border-color: #FF8800;padding: 9px 22px;" @click="$router.push('/caiwu')">立即充值</el-button>
              <el-button type="primary" style="background-color: #04BAF0;border-color: #04BAF0;color: #F2F2F2;padding: 9px 22px;" @click="$router.push('/caiwu2')">收支明细</el-button>
            </div>
          </div>
        </div>
      </div>
      <!--<div class="tier-1-block ub-box z-margin-top-20-precent ub-col">
        <div class="home-panel-heading-notic ub-box z-font-size-16">
            <span class="notice-title z-textAlign-center z-font-size-18 z-padding-h-20-precent" style="color:red;">
									促销专区
            </span>
          <a href="/act/" target="_blank" class="z-font-size-14 z-color-blue z-padding-left-20-precent" style="line-height: 49px;">更多特惠产品 &gt;&gt;</a>
        </div>
        <div v-for="item in actList" class="pkg-card pkg-card-col">
          <div class="pkg-title"><em>{{item.cpu}}</em>核<em>{{item.ram}}</em>G</div>
          <div class="pkg-deploy cf">
            <div class="dropdown ">
              <div class="ui-title">数据中心</div>
              <div class="ui-title"><span v-if="item.NET_TYPE === 'BJBGP'">北京BGP</span><span v-if="item.NET_TYPE === 'DLBGP'">多线BGP</span></div>
            </div>
            <div class="dropdown ">
              <div class="ui-title">带宽</div>
              <div class="ui-title">{{item.NET_WIDTH}}M</div>
            </div>
            <div class="dropdown ">
              <div class="ui-title">数据盘</div>
              <div class="ui-title">{{item.disc}}G</div>
            </div>
            <div class="dropdown ">
              <div class="ui-title">免费获赠</div>
              <div class="ui-title">操作系统盘</div>
            </div>
          </div>
          <div class="pkg-order">
            <p class="price">
              <span class="pkg-price">¥{{item.price}}</span>
              <span class="unit darkgray">元/
              <span v-if="item.p_time == 1">首月</span>
              <span v-if="item.p_time == 12">年</span>
              <span v-if="item.p_time == 24">两年</span>
              <span v-if="item.p_time == 36">三年</span>
              </span>
            </p>
            <a class="btn-m btn-red pkg-href" @click="addCart(item.vps_try_id)" target="_blank" href="javascript:;">立即购买</a>
          </div>
        </div>
        &lt;!&ndash;<div class="notice-list-panel ub-box">
          <ul class="z-width-100-precent">
            <li v-for="(item,index) in actList" class="ub-box">
              云服务器：<span v-if="item.NET_TYPE == 'DLBGP'">大连BGP</span><span v-if="item.NET_TYPE == 'BJBGP'">北京BGP</span>、{{item.ram}}G内存、{{item.cpu}}核CPU、{{item.NET_WIDTH}}M带宽、{{item.disc}}G SSD数据盘 、送操作系统盘，<span v-if="item.p_time == 1">首月只需</span><span v-if="item.p_time != 1">{{Math.floor(item.p_time/12)}}年</span> <font style="font-size:20px; color:red">{{item.price}}</font>元，
              <a class="z-color-a a-underline-link" href="javascript:;" @click="addCart(item.NET_TYPE,item.cpu,item.ram,item.disc,item.NET_WIDTH,item.price,item.p_time)">加入购物车</a>
            </li>
            <li>
              <p v-html="actmsg"></p>
            </li>
          </ul>
        </div>&ndash;&gt;
      </div>-->
      <div class="home-tier-3 z-margin-top-20-precent">
        <div class="home-panel-heading">
          <span class="z-lineHeight-20 z-font-size-16">已开通产品</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="8">
            <router-link to="/product">
              <div class="grid-content bg-purple ub-box">
                <div class="product-left ub-box ub-ver ub-ver-v">
                  <div class="product-num" :class="{'notzero': product.freehost_count != 0}">
                    {{product.freehost_count}}
                  </div>
                </div>
                <div class="product-right">
                  <h4 class="z-font-size-15 z-lineHeight-30">免费虚拟主机</h4>
                  <p>开通即用、永久免费、送免备案服务</p>
                </div>
              </div>
            </router-link>
          </el-col>
          <el-col :span="8">
            <router-link to="/freeServerList">
              <div class="grid-content bg-purple ub-box">
                <div class="product-left ub-box ub-ver ub-ver-v">
                  <div class="product-num" :class="{'notzero': product.freevps_count != 0}">
                    {{product.freevps_count}}
                  </div>
                </div>
                <div class="product-right">
                  <h4 class="z-font-size-15 z-lineHeight-30">免费云服务器</h4>
                  <p>永久免费、功能强大、送免备案服务</p>
                </div>
              </div>
            </router-link>
          </el-col>
          <el-col :span="8">
            <router-link to="/freeBeian">
              <div class="grid-content bg-purple ub-box">
                <div class="product-left ub-box ub-ver ub-ver-v">
                  <div class="product-num" :class="{'notzero': product.mba_domain != 0}">
                    {{product.mba_domain}}
                  </div>
                </div>
                <div class="product-right">
                  <h4 class="z-font-size-15 z-lineHeight-30">免备案服务</h4>
                  <p>提交域名无需备案即可访问</p>
                </div>
              </div>
            </router-link>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <router-link to="/vhostList">
              <div class="grid-content bg-purple ub-box">
                <div class="product-left ub-box ub-ver ub-ver-v">
                  <div class="product-num" :class="{'notzero': product.vhost_count != 0}">
                    {{product.vhost_count}}
                  </div>
                </div>
                <div class="product-right">
                  <h4 class="z-font-size-15 z-lineHeight-30">虚拟主机</h4>
                  <p>共享和独享IP虚拟主机随意选</p>
                </div>
              </div>
            </router-link>
          </el-col>
          <el-col :span="8">
            <router-link to="/serverList">
              <div class="grid-content bg-purple ub-box">
                <div class="product-left ub-box ub-ver ub-ver-v">
                  <div class="product-num" :class="{'notzero': product.vps_count != 0}">
                    {{product.vps_count}}
                  </div>
                </div>
                <div class="product-right">
                  <h4 class="z-font-size-15 z-lineHeight-30">云服务器</h4>
                  <p>不同配置满足您不同的应用</p>
                </div>
              </div>
            </router-link>
          </el-col>
          <el-col :span="8">
            <router-link to="/domainList">
              <div class="grid-content bg-purple ub-box">
                <div class="product-left ub-box ub-ver ub-ver-v">
                  <div class="product-num" :class="{'notzero': product.domain_count != 0}">
                    {{product.domain_count}}
                  </div>
                </div>
                <div class="product-right">
                  <h4 class="z-font-size-15 z-lineHeight-30">域名</h4>
                  <p>各种后缀域名，开启网络第一步</p>
                </div>
              </div>
            </router-link>
          </el-col>
        </el-row>
      </div>
      </div>
      <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
      <el-dialog title="重要通知" :lock-scroll="true" :visible="dialognotice" width="660px" :show-close="false">
        尊敬的阿贝云用户，即日起海外线路进行调整，预计在9月15日之前恢复，在此期间海外线路将无法访问。国内线路访问不受影响。
        <br>

        另：针对近期的网络攻击恶性事件，阿贝云已经全面加入中国电信的云堤防御体系，目前线路正在调测中,如有个别访问异常，请您耐心等待调测完毕后即可正常。
        <br>

        2018年9月12日
        <br>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialognotice = false">关闭通知</el-button>
        </div>
      </el-dialog>
      <!--blackpink-->
      <div v-if="dialogShadow" class="dialogShadow"></div>
      <dl v-if="dialogShadow" class="dialogBody ub-box ub-col">
      <dd class="dialogTitle z-font-size-16">
        <span class="z-font-size-18 z-padding-left-10-precent">提示信息</span>
        <a class="aui_close" href="javascript:;" @click="clickBtn()">×</a>
      </dd>
      <dd class="dialogContent z-color-666 z-font-size-15 ">
        <img style="margin-left: 30px;margin-right: 30px;vertical-align: middle" src="../../assets/imgs/uc_warn.png" alt="">
        <span class="z-font-size-15" v-if="info ==='smrz_fail'">您的帐户还没有实名认证</span>
        <span class="z-font-size-15" v-if="info !='smrz_fail'">{{info}}</span>
        <br>
        <router-link v-if="info ==='smrz_fail'" to="/auth" class="z-color-a z-font-size-15" style="display: inline-block;margin-left: 127px">点击这里实名认证</router-link>
        <router-link v-if="info !='smrz_fail'" to="/caiwu" class="z-color-a z-font-size-15" style="display: inline-block;margin-left: 200px">点击充值</router-link>
      </dd>
      <div class="dialogFooter ub-f1 ub-box ub-ver z-padding-v-15-precent">
        <!--<dd class="confirmBtn z-relative z-color-fff z-curPonit" @click="clickBtn(true)" style="background:#2ebace;">确认</dd>
        <dd class="confirmBtn z-relative z-color-fff z-curPonit" @click="clickBtn(false)" style="">取消</dd>-->
      </div>
    </dl>
    </div>
  </div>
</template>
<script>
  import { MessageBox } from 'element-ui';
  import Xbutton from 'commons/Xbutton.vue'
  import XhomeTable from 'components/commons/XhomeTable.vue'
  import Xul from 'components/commons/Xul.vue'
  import userService from 'business/userService.js'
  import helpService from 'business/helpService.js'
  import VpsService from 'business/VpsService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import {mapGetters,mapActions} from 'vuex'
  export default {
    data () {
      return {
        dialognotice:false,
        dialogLoading:false,
        dialogShadow:false,
        ajax:false,
        cname:'',
        username: '',
        userid: '',
        phone: '',
        email: '',
        money: '0',
        smoney: '00',
        couponIndex: 0,
        couponList: [],
        gonggaoList: [

        ],
        actmsg:'',
        actList:[],
        userList: [],
        product:{},
        columns: [
          {
            label: '我的业务',
            key: 'name',
            col: 'icon',
          },
          {
            label: '拥有数量',
            key: 'num',
            category: 'Xspan',
            col: 'all',
          },
          {
            label: '即将到期',
            key: 'soonnum',
            category: 'Xspan',
            col: 'over',
          },
          {
            label: '已经到期',
            key: 'latenum',
            category: 'Xspan',
            col: 'pre',
          }
        ],
        couponcolumns: [
          {
            label: '编号',
            key: 'name',
          },
          {
            label: '面值',
            key: 'money',
            col: 'mian'
          },
          {
            label: '过期时间',
            key: 'istime',
          }
        ],
        currentPage: 0,
        counts: 12,
        info:'',
        Sales: []
      }
    },
    components: {
      XdialogLoading,
      XhomeTable,
      Xbutton,
      Xul
    },
    props:{
      flag:Boolean,
      hide:Boolean
    },
    mounted(){
      this.getAllUser('userInfo','cmd=userinfo')
      this.getGonggao()
      /*this.getAct()*/
      this.getActList()
    },
    methods: {
      ...mapActions(['SETFIRST_MENU','SETSECOND_MENU','SETTHREE_MENU']),
      async getAllUser(urlType,data) {
        let {vueData, state} = await userService.transformToVue(urlType,'POST',data)
        if(state.code === '000' ) {
          this.product = vueData.msg.product
          let msg = vueData.msg
          let onuse = msg.yhq.onuse.map((item, index) => {
            return {
              name: item.yhq_id,
              mian: [
                {
                  font: item.money_all.split('.')[0],
                  type: 'white',
                  optionStyle:{padding: '.4rem .8rem .4rem .65rem',background: '#00c0ff',width: '2rem',height: '1rem', margin: '.6rem 0 0 .2rem',lineHeight: '1rem'},
                }
              ],
              istime: item.end_time.split(' ')[0],
            }
          })
          let onuselength = msg.yhq.onuse.length
          let timeout = msg.yhq.timeout.map((item, index) => {
            return {
              name: item.yhq_id,
              mian: [
                {
                  font: item.money_all.split('.')[0],
                  type: 'white',
                  optionStyle:{padding: '.4rem .8rem .4rem .65rem',background: '#00c0ff',width: '2rem',height: '1rem', margin: '.6rem 0 0 .2rem',lineHeight: '1rem'},
                }
              ],
              istime: item.end_time.split(' ')[0],
            }
          })
          let timeoutlength = msg.yhq.timeout.length
          let used = msg.yhq.used.map((item, index) => {
            return {
              name: item.yhq_id,
              mian: [
                {
                  font: item.money_all.split('.')[0],
                  type: 'white',
                  optionStyle:{padding: '.4rem .8rem .4rem .65rem',background: '#00c0ff',width: '2rem',height: '1rem', margin: '.6rem 0 0 .2rem',lineHeight: '1rem',},
                }
              ],
              istime: item.end_time.split(' ')[0],
            }
          })
          let usedlength = msg.yhq.used.length
          let onusecon = onuse.slice(0,3)
          let timeoutcon = timeout.slice(0,3)
          let usedcon = used.slice(0,3)
          this.cname = msg.cert_state
          this.username = msg.cert_name || msg.ID_Mobile
          this.userid = msg.userid
          this.phone = msg.ID_Mobile ? msg.ID_Mobile : '立即绑定>>'
          this.email = msg.ID_Email ? msg.ID_Email : '立即绑定>>'
          let money = msg.money || "0";
          if (String(money).indexOf(".") == -1) {
            money += ".00";
          }
          this.money = money.split('.')[0]
          this.smoney = money.split('.')[1]

          this.couponList = [
            {
              babel: '可用优惠券',
              content: onusecon,
              length: onuselength
            },
            {
              babel: '已用优惠券',
              content: usedcon,
              length: usedlength
            },
            {
              babel: '过期优惠券',
              content: timeoutcon,
              length: timeoutlength
            }
          ]
          this.userList = [{
            name:'域名',
            num: vueData.msg.product.domain_count_all,
            pre: vueData.msg.product.domain_count_pre,
            over: vueData.msg.product.domain_count_over
          }, {
            name:'虚拟主机',
            num: vueData.msg.product.vhost_count_all,
            pre: vueData.msg.product.vhost_count_pre,
            over: vueData.msg.product.vhost_count_over
          }, {
            name:'云服务器',
            num: vueData.msg.product.vps_count_all,
            pre: vueData.msg.product.vps_count_pre,
            over: vueData.msg.product.vps_count_over
          }]
          this.ajax = true
        }else {
          this.$toast({tip:'请刷新页面...',type:'3'})
        }
      },
      async getGonggao() {
        let {vueData, state} = await helpService.transformToVue('helpInfo','POST','cmd=query&type_id=257')
        if(vueData.response==200){
          this.gonggaoList = vueData.msg.content
        }else {
          this.$toast({tip:'请刷新页面...',type:'3'})
        }
      },
      async getAct() {
        let {vueData, state} = await userService.transformToVue('actInfo','POST','cmd=get_content')
        if(vueData.response==200){
          this.actmsg = vueData.msg
        }else {
          this.$toast({tip:'请刷新页面...',type:'3'})
        }
      },
      async getActList() {
        let {vueData, state} = await userService.transformToVue('actInfoXin','POST','cmd=get_Promotion_list')
        if(vueData){
          this.Sales = vueData.map((item)=>{
            return {...item,y_price2:item['2y_price'],y_price3:item['3y_price'],cx_time:6}
          })
          // this.actList = vueData
          // let sales_m = vueData.slice(0,11);
          // let sales_y = vueData.slice(11,22);
          // console.log(sales_m)
          // console.log(sales_y)
          // this.Sales = sales_m.map((item,index)=>{
          //   let price_y, vps_try_id_y;
          //   sales_y.map((x,y)=>{
          //     if(y == index){
          //       price_y = x.price;
          //       vps_try_id_y = x.vps_try_id;
          //     }
          //   })
          //   return{
          //     id:index,
          //     cpu: item.cpu,
          //     ram: item.ram,
          //     net: item.NET_WIDTH,
          //     ssd: item.disc,
          //     price_y: price_y,
          //     price_m: item.price,
          //     net_type:item.NET_TYPE,
          //     time:price_y ? 12 : 1,
          //     vps_try_id:item.vps_try_id,
          //     vps_try_id_y:vps_try_id_y,
          //   }
          // })

        }else {
          this.$toast({tip:'请刷新页面...',type:'3'})
        }
      },
      async addCart(item) {
        MessageBox.confirm('将从您账户中扣除相应费用', '是否开通？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'warning'
        }).then(async() => {
          let data = 'cmd=vps_try'+
            '&vps_try_id=' + item.vps_try_id +
            '&cx_time=' + item.cx_time
          this.dialogLoading = true
          let {vueData, state} = await VpsService.transformToVue('vpsInfoXin','POST',data)
          if(vueData.response==200){
            this.dialogLoading = false
            let self = this
            this.$dialog({type:'success', info: vueData.msg, click () {self.$router.push('/serverList')}})
          }else {
            this.dialogLoading = false
            if(vueData.msg === 'smrz_fail'){
              this.info = vueData.msg
              this.dialogShadow = true
            }else if(vueData.response == 500999){
              this.info = vueData.msg
              this.dialogShadow = true
            }else {
              this.$dialog({type:'error', info: vueData.msg, click () {}})
            }
          }
        }).catch(() => {

        });
      },
      /*async addCart(type,cpu,ram,ssd,net_width,price,ptime) {
        let data = 'cmd=add_cart'+
                   '&p_type=vps'+
                   '&p_time='+ ptime +
                   '&count=1'+
                   '&CPU='+ cpu +
                   '&RAM='+ ram +
                   '&SSD='+ ssd +
                   '&NET_TYPE='+ type +
                   '&NET_WIDTH='+ net_width +
                   '&price='+ price
        this.dialogLoading = true
        let {vueData, state} = await userService.transformToVue('cartInfo','POST',data)
        if(vueData.response==200){
          this.dialogLoading = false
          this.$dialog({type:'success', info: vueData.msg, click () {
              window.open('https://www.abeiyun.com/cart/')
            }})

        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },*/
      clickCoupon(idx) {
        this.couponIndex = idx
        Array.from(this.$refs.couponItems).forEach((item, inx)=>{
          if( inx === idx ) {
            item.style.display = 'block'
          }else {
            item.style.display = 'none'
          }
        })
      },
      moreCoupon() {
        sessionStorage.setItem('secondMenu',2)
        sessionStorage.setItem('threeMenu',0)
        this.$router.push('/voucher')
      },
      clickBtn() {
        this.dialogShadow = false
      }
    }
  }
</script>
<style scoped>
  .newpage { margin-left: 80px; }
  .hideleft { margin-left: 80px; }
  .page-main { background-color: #f6f5fa; border: 0;}
  .home-tier-1 { height: 260px; }
  .tier-1-block { background-color: #fff; border: 1px solid #eaedf1;}
  .home-tier-2 { height: 92px; background-color: #fff; border: 1px solid #eaedf1;}
  .home-tier-3 { height: 240px; padding: 0 2rem 2.6rem 2rem; background-color: #fff; border: 1px solid #eaedf1;}
  .user-detail-container { height: 156px;background-color: #3fa0dc;color: #fff;width: 100%; }
  .user-avatar {width: 130px;vertical-align: middle;}
  .user-avatar-container { width: 100px; height:100px; background: #74d0e9; border-radius: 50px;}
  .user-img-container { width: 80px; height:80px; background: #ffff; border-radius: 40px;}
  .user-label {
    display: inline-block;
    width: 16px;
    min-width: 16px;
    height: 16px;
    background: no-repeat center;
    margin: 4px 22px 0 4px;
  }
  .un-auth { vertical-align: -8%; }
  .user-verified-origin {
    background-image: url(../../assets/imgs/home_icon_vip_gray.png);
  }
  .auth_inauth {
    background-image: url(../../assets/imgs/auth_inauth.png);
  }
  .user-connect { height: 4.2rem; line-height: 4.1rem; }
  .connect-icon-mobile { padding-left: 2.5rem; background: url(../../assets/imgs/home_icon_mobile.gif) no-repeat 2px center;}
  .connect-icon-email { padding-left: 2.5rem; background: url(../../assets/imgs/home_icon_email.gif) no-repeat 2px center;}
  .user-connect:first-child {border-bottom: 1px solid #eee;}
  .secretary-detail img {position: absolute;bottom: 10px;left: 58%;width: 100px;height: 100px;margin-left: -61px;}
  .operate-container { padding: 2.6rem 2rem; }
  .operate-links { line-height: 2.8rem; }
  .detail-count-container {margin-right: 2.0rem;color: #ff8800;}
  .home-panel-heading {
    padding: 1.8rem 0;
  }
  .home-panel-heading-notic {
    border-bottom: 1px solid #eee;
    padding-right: 20px;
    background-color: #fafafa;
    line-height: 3.9rem;
    color: #606f80;
  }
  .notice-title {
    display: inline-block;
    border-top: 3px solid #009FD9;
    border-right: 1px solid #eee;
    color: #009FD9;
    background: #fff;
  }
  .notice-title2 {
    display: inline-block;
    border-top: 3px solid #009FD9;
    border-right: 1px solid #eee;
    color: #ff0000;
    background: #c9d2f3;
    font-style: italic;
    font-weight: bold;
  }
  .notice-list-panel {
    padding: 5px 18px;
  }
  .notice-list-panel li:first-child {
    border-top: none;
  }
  .notice-list-panel li {
    line-height: 3.3rem;
    border-top: 1px dashed #eee;
  }
  .list-decoration-point {
    color: #009FD9;
  }
  .notice-content {
    display: inline-block;
    max-width: 70%;
  }
  .home-nav >li >a {
    color: #fff;
    cursor: pointer;
    background-color: #75808e;
    border: none;
    border-bottom-color: transparent;
    display: block;
    padding: .8rem 1.5rem;
  }
  .home-nav >li.active >a {
    color: #555;
    cursor: default;
    background-color: #fff;
    border: none;
    border-bottom-color: transparent;
  }
  .tab-content {
    height: 16rem;
    padding: 0 1rem;
  }
  .tab-content .tab-pane {
    display: none;
  }
  .tab-content .tab-pane.active{
    display: block;
  }
  .el-row {
    margin-bottom: 20px;
  &:last-child {
     margin-bottom: 0;
   }
  }
  .bg-purple {
    background: #f6f7fb;
  }
  .grid-content {
    min-height: 80px;
    border: 1px solid #fff;
  }
  .grid-content:hover {
    border: 1px solid #02b9ef;
  }
  .grid-content:hover .product-num{
    background-color: #02b9ef;
  }
  .grid-content:hover .product-right h4{
    color: #02b9ef;
  }
  .product-left {
    width: 80px;
    height: 80px;
    background-color: #eceff9;
  }
  .product-right {
    padding: 1.2rem;
  }
  .product-right h4 {
    color: #000;
  }
  .product-num {
    width: 40px;
    height: 40px;
    background-color: #ccd5f0;
    border-radius: 20px;
    line-height: 40px;
    text-align: center;
    font-size: 21px;
    color: #fff;
  }
  .product-num.notzero {
    background-color: #5c74bd;
  }
  .auth-bg {
    display: inline-block;
    position: absolute;
    top: -25px;
    right: -4px;
    background-color: #000;
    color: #fff;
    width: 72px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    border-radius: 2px;
  }
  .auth-bg-icon {
    display: inline-block;
    position: absolute;
    bottom: -7px;
    left: 32px;
    width: 11px;
    height: 7px;
    background: url(../../assets/imgs/sanjiao.png) no-repeat;
  }
  .act-left {
    width: 184px;
    height: 184px;
    min-width: 184px;
  }
  .act-right {
    padding: 7px 0 4px 12px;
  }
  .dialogShadow{position:fixed;z-index:9900;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.5);}
  .dialogBody{position:fixed;z-index:9909;top:37%;left:50%;transform:translateX(-50%);min-width:32rem;background:#fff;box-shadow: 0 0 10px 3px rgba(0,0,0,.2);animation:dialogAnimStart .2s forwards}
  .dialogTitle{position:relative;padding:1rem 0;background:#f7f9fa;color:#636566;}
  .dialogContent{padding: 2rem 2rem 2rem 0}
  .dialogFooter{background:#f7f9fa;}
  @keyframes dialogAnimEnd{
    from{opacity:1}
    to{opacity:0}
  }
  .aui_close {
    position: absolute;
    padding: 0;
    top: 31%;
    right: 22px;
    width: 21px;
    height: 21px;
    line-height: 21px;
    font-size: 30px;
    color: #636566;
    text-align: center;
    font-family: Helvetica, STHeiti;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/index.vue